import React, { Component } from 'react';
import XLSX from 'xlsx';

class SysadminUserUserUploadUserExcel extends Component {
    onChange(e) {
        const rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
        let files = e.target.files;
        let file = files[0];
        let reader = new FileReader();
        reader.onload = (e) => {
            let data = e.target.result;
            if(!rABS) data = new Uint8Array(data);
            const workbook = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
            // console.log(workbook);
            const first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
            // console.log(first_worksheet);
            const workbookJson = XLSX.utils.sheet_to_json(first_worksheet, {
                header: 1,
                // range: 16,
                range: 'A17:AE500',
                raw: false,
                defval: null,
                blankrows: false
            });
            // console.log(workbookJson);
            this.props.processNewExcelData(workbookJson);
        }
        if(rABS) reader.readAsBinaryString(file); 
        // else reader.readAsArrayBuffer(file);

        // reader.readAsBinaryString(files[0]);
        // reader.onload = (e) => {
        //     const workbook = XLSX.read(e.target.result, {
        //         type: 'binary'
        //     });
        //     // console.log('workbook', workbook);
        //     const first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
        //     const workbookJson = XLSX.utils.sheet_to_json(first_worksheet, {
        //         header: 1,
        //         range: 16,
        //         raw: false,
        //         defval: null,
        //     });
        //     console.log(workbookJson);
        //     this.props.processNewExcelData(workbookJson);
        // }
    }
    render() {
        return (
            <div onSubmit={this.onFormSubmit}>
                <input type="file" name="file" onChange={(e)=>this.onChange(e)} />
            </div>
        );
    }
}

export default SysadminUserUserUploadUserExcel;